import { clearExpandedCategories } from 'actions';
import LinkLookup from 'components/LinkLookup';
import daysAgo from 'components/utils/daysAgo';
import React from 'react';
import { useDispatch } from 'react-redux';
import type { MModel, UUID } from 'types';
import logEvent from 'utils/analytics';

type ComponentProps = {
  model: MModel;
  selected: boolean;
  handleModelSelect: (checked: boolean, uuid: UUID) => void;
  showModels: boolean;
};

const ModelListItem: React.FC<ComponentProps> = ({
  model,
  selected,
  handleModelSelect,
  showModels,
}) => {
  const dispatch = useDispatch();

  const handleRowCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    e.stopPropagation();

    handleModelSelect(e.target.checked, model.uuid);
    const element = document.activeElement as HTMLInputElement;
    if (element) {
      element.blur();
    }
  };

  return (
    <>
      <LinkLookup
        routeName={model.unSaved ? 'global-models-list' : 'global-model-manager'}
        routeParams={model.unSaved ? {} : { modelId: model.uuid }}
        className={`${
          model.unSaved ? 'opacity-25' : ''
        } border-t border-gray-200 hover:bg-gray-100 table-row`}
        onClick={(): void => {
          dispatch(clearExpandedCategories());
          logEvent('single-use-case');
        }}
        as="tr"
      >
        <td className="table-wrapper__new-td flex-col items-center justify-center ">
          <div className="flex flex-col items-center justify-center  min-h-8 ">
            <input
              id={`checkbox-user-${model.uuid}`}
              data-testid="select-button"
              type="checkbox"
              className="cursor-pointer form-checkbox litlingo-checkbox w-5 h-5"
              onClick={(e): void => e.stopPropagation()}
              onChange={(e): void => {
                handleRowCheckboxChange(e);
              }}
              checked={selected}
            />
          </div>
        </td>
        <td className="table-wrapper__new-td">
          <div className="flex items-center text-body">
            <div className="overflow-hidden">
              <div className="truncate font-bold">{model.name}</div>
            </div>
          </div>
        </td>
        <td className="table-wrapper__new-td">
          <div className="flex items-center text-body">
            <div className="overflow-hidden">
              <div className="truncate">{model.description}</div>
            </div>
          </div>
        </td>

        <td className="table-wrapper__new-td">
          <div className="flex items-center text-body">
            <div className="overflow-hidden">
              <div className="truncate">{model.priority}</div>
            </div>
          </div>
        </td>

        <td className="table-wrapper__new-td">
          <div className="text-body">{model.updated_at != null && daysAgo(model.updated_at)}</div>
        </td>

        <td className="table-wrapper__new-td">
          <div className="text-body">{model.updated_by && `By ${model.updated_by.name}`}</div>
        </td>
      </LinkLookup>
      {selected && showModels && (
        <>
          {model.categories
            ?.filter(
              (c, index, self) =>
                self.findIndex((item) => item.rule?.uuid === c.rule?.uuid) === index
            )
            .map((c) => (
              <tr
                key={c.uuid}
                className="border-t border-gray-200 bg-litlingo-gray-0.5 table-row h-8"
              >
                <td className="table-wrapper__new-td pl-15 text-body" colSpan={2}>
                  {`${c.rule?.name}`}
                </td>
                <td colSpan={6} className="pl-8">
                  <div className="flex flex-col ">
                    <div>{c.outcome?.name}</div>
                  </div>
                </td>
              </tr>
            ))}
        </>
      )}
    </>
  );
};

export default ModelListItem;
